//# sourceMappingURL=jquery.viewportchecker.min.js.map
// import external dependencies
import 'jquery';
// import 'tilt.js';
import './autoload/jquery-viewport-checker';
import 'slick-carousel';
// import 'jquery-plugin-viewport-checker';
// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/jquery-viewport-checker.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import './routes/modal';
import gallery from './routes/gallery';
import aboutUs from './routes/about';
import singleCar from './routes/singleCar';
import pageWorks from './routes/pageWorks';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  gallery,
  aboutUs,
  singleCar,
  pageWorks,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js